import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import patientImg from '../../assets/img/patient.png'
import yappImg from '../../assets/img/ic_yapp.png'
import loadingYapp from '../../assets/img/yapp_loading.gif'
import CardInteracion from '../../Components/CardInteraction/CardInteracion'
import { getProgramsByType, getS3File } from '../../Utils/api'
import { addEvent, logEvent } from '../../Utils/utils'

const _get = require('lodash/get')

function Programs() {
  const history = useHistory()
  const [loading, setLoading] = useState(null)

  function goBack() {
    history.goBack()
  }

  const onClickOption = (type) => {
    setLoading(true)
    if (type === 'YAPP') {
      addEvent('click-webapp-programs-yapp')
    } else {
      addEvent('click-webapp-programs-patient')
    }

    getProgramsByType(type)
      .then((resp) => {
        if (![undefined, null].includes(resp)) {
          if (type === 'YAPP') {
            let file = _get(resp, 'data[0].file')
            logEvent('Material Checked', {
              'Material Type': 'Program',
              'Origin Material': 'Programs',
              'Material Id': resp.data[0]?.id,
              'Material Name': resp.data[0]?.name,
            })
            if (file) {
              getS3File(file, process.env.REACT_APP_BUCKETS_YAPP)
                .then((res) => {
                  history.push('/pdf/viewer', { url: res?.data?.url })
                })
                .catch((err) => console.log(err))
            } else {
              console.log('No se encontro ruta del archivo')
            }
          } else {
            history.push('/pro/programs/detail', { type })
          }
        } else {
          console.log('No se encontro información desde el servicio.')
        }
      })
      .catch(console.log)
  }

  return (
    <>
      <div className='py-3 px-3'>
        <div
          id={'gtm-medication-sheet-result'}
          className="content-responsive mx-auto d-flex justify-content-between">
          <div className="breadcrumbs c-pointer" onClick={goBack}>
            <a className="d-flex align-items-center">
              <i className="icon-chevron-right icon-reverse"></i>
            </a>
            <span className="title-primary--regular line-14">Volver</span>
          </div>
        </div>
      </div>

      <div className="flex-grow-1 px-3">
        <div>
          <div className="content-responsive mx-auto">
            {loading ? (
              <img
                src={loadingYapp}
                alt="loading"
                className="loading-yapp--alternative mx-auto mt-5"
              />
            ) : (
              <div className="py-4">
                <h2 className="title-primary--xxl mb-2">
                  Información de Programas
                </h2>
                <p className="txt-paragraph line-16 mb-4">
                  Toda la información que necesitas acerca de los programas para
                  ayudar a tus pacientes.
                </p>
                <div className="content-card-product">
                  <CardInteracion
                    id="gtm-webapp-programs-yapp"
                    className="mh-95"
                    doAction={() => onClickOption('YAPP')}>
                    <div className="content-img-programs">
                      <img
                        src={yappImg}
                        alt={`Programas Yapp`}
                        className="img-mw-40"
                      />
                    </div>
                    <div className="ml-2 overflow-hidden">
                      <h2 className="title-primary mb-1 line-16 pr-2 text-ellipsis--2 ">
                        Programas Yapp
                      </h2>
                      <p className="txt-paragraph--small m-0 line-14 text-ellipsis--2 ">
                        Infórmate sobre programas de pacientes que ofrece Yapp.
                      </p>
                    </div>
                  </CardInteracion>
                  <CardInteracion
                    id="gtm-webapp-programs-patient"
                    className="mh-95"
                    doAction={() => onClickOption('PATIENTS')}>
                    <div className="content-img-programs">
                      <img
                        src={patientImg}
                        alt={`Programas de pacientes`}
                        className="img-mw-40"
                      />
                    </div>
                    <div className="ml-2 overflow-hidden">
                      <h2 className="title-primary mb-1 line-16 pr-2 text-ellipsis--2 ">
                        Programas de pacientes
                      </h2>
                      <p className="txt-paragraph--small m-0 line-14 text-ellipsis--2 ">
                        Infórmate sobre programas de pacientes que ofrecen distintos laboratorios.
                      </p>
                    </div>
                  </CardInteracion>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Programs
